import React from 'react'
import Inner from '../component/Innerbanner'
function Mugs() {
  return (
      <Inner name="Mugs" title="Home . Mugs   " />
  )
}

export default Mugs